var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_ClaimType_form_newTitle"),
      widthClass: "max-1000",
      pad: "0",
      backgroundClass: _vm.curStep == 4 ? "transparent" : "",
      initData: _vm.ClaimTypeData,
      checkData: [
        "claim_type_name",
        "claim_type_description",
        "claim_type_code",
        "claim_type_property_group_uuid",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: {
                curStep: _vm.curStep,
                items: _vm.stepper,
                contentClass: _vm.curStep == 4 ? "mrc-grey pa-0" : "white pa-8",
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "pa-2",
                          attrs: { "lazy-validation": "" },
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "white" },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "100",
                                      bindData:
                                        _vm.ClaimTypeData.claim_type_name,
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypeNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.ClaimTypeData.claim_type_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("numberInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_sequenceLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 11]
                                      ),
                                      maxlength: "11",
                                      max: 1000,
                                      min: 0,
                                      placeholder: _vm.$t(
                                        "label_essweb_ClaimType_form_sequenceLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.ClaimTypeData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimTypeData,
                                          "sequence",
                                          $$v
                                        )
                                      },
                                      expression: "ClaimTypeData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypeCodeLabel"
                                      ),
                                      maxlength: "100",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypeCodeLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.ClaimTypeData.claim_type_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimTypeData,
                                          "claim_type_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimTypeData.claim_type_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_ClaimType_form_claimTypePropertyGroupLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.ClaimTypePorpertyGroup,
                                      "item-text":
                                        "claim_type_property_group_name",
                                      "item-value": "uuid",
                                      "append-icon": "arrow_drop_down",
                                      filled: "",
                                      "single-line": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_ClaimType_form_claimTypePropertyGroupLabel"
                                      ),
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.ClaimTypeData
                                          .claim_type_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimTypeData,
                                          "claim_type_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimTypeData.claim_type_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.ClaimTypeData
                                          .claim_type_description,
                                      maxlength: "500",
                                      label: _vm.$t(
                                        "label_essweb_ClaimType_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.ClaimTypeData.claim_type_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.claimTypeTransactionHeaders,
                          items: _vm.claimTypeTransactions,
                          border: "",
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_transaction_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.code",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.claim_transaction_type_code
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEditTransactionType(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("edit")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toDeleteTransactionType(
                                          item.uuid
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("delete")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "my-2 text-capitalize",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.newTransactionTypeDialog = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimType_form_dialog_addClaimTypeTransactionTypeBtnLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.ApprovalFlowHeaders,
                          items: _vm.ApprovalFlows,
                          border: "",
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.amount",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [_vm._v("≥" + _vm._s(item.amount))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.approval_flow_template_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEditApprovalFlow(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("edit")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toDeleteApprovalFlow(
                                          item.uuid
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("delete")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "my-2 text-capitalize",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.newApprovalFlowDialog = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimType_form_dialog_addapprovalFlowBtnLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-4",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "max-width rounded-lg transparent" },
                        [
                          _c(
                            "v-tabs",
                            {
                              staticClass: "mrc-grey",
                              attrs: {
                                vertical: "",
                                "background-color": "var(--taber-nav-color)",
                                "hide-slider": "",
                              },
                              model: {
                                value: _vm.lefttab,
                                callback: function ($$v) {
                                  _vm.lefttab = $$v
                                },
                                expression: "lefttab",
                              },
                            },
                            [
                              _c("v-sheet", {
                                staticClass: "rounded-t-lg",
                                attrs: { height: "8", width: "200" },
                              }),
                              _c(
                                "v-tab",
                                {
                                  staticClass:
                                    "white text-capitalize px-3 mr-2 text-left text-truncate",
                                  class:
                                    _vm.lefttab == 0
                                      ? "primary lighten-5 text--primary"
                                      : "",
                                  staticStyle: { width: "200px" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "max-width text-left text-truncate",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_ClaimType_form_tab_beforeNoticeLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-tab",
                                {
                                  staticClass:
                                    "white text-capitalize px-3 mr-2 text-left text-truncate",
                                  class:
                                    _vm.lefttab == 1
                                      ? "primary lighten-5 text--primary"
                                      : "",
                                  staticStyle: { width: "200px" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "max-width text-left text-truncate",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_ClaimType_form_tab_afterNoticeLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("v-sheet", {
                                staticClass: "rounded-b-lg",
                                attrs: { height: "8", width: "200" },
                              }),
                              _c(
                                "v-tab-item",
                                { staticClass: "mrc-grey" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "white",
                                      attrs: { elevation: 0 },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "transparent pa-8" },
                                        [
                                          _c(
                                            "v-container",
                                            {
                                              staticClass:
                                                "mrc-grey rounded-lg",
                                              attrs: { fluid: "" },
                                            },
                                            _vm._l(
                                              _vm.beforeNoticeList,
                                              function (item, index) {
                                                return _c(
                                                  "v-sheet",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "rounded-lg pa-0 drag my-2",
                                                  },
                                                  [
                                                    _c("v-hover", {
                                                      attrs: {
                                                        "open-delay": "100",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var hover =
                                                                ref.hover
                                                              return [
                                                                _c(
                                                                  "v-card",
                                                                  {
                                                                    staticClass:
                                                                      "pa-2 d-flex rounded-lg align-center",
                                                                    attrs: {
                                                                      elevation:
                                                                        hover
                                                                          ? 4
                                                                          : 2,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "grey",
                                                                          iconClass:
                                                                            "dragvertical",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "black",
                                                                          iconClass:
                                                                            "arrow01",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-body-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                item[
                                                                                  "claim_type_notice_point_" +
                                                                                    item.number
                                                                                ]
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-spacer"
                                                                    ),
                                                                    hover
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.toEditNotice(
                                                                                    item,
                                                                                    "before"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "edit"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    hover
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onDeleteNotice(
                                                                                    item.number,
                                                                                    "before"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "delete"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "v-form",
                                            { ref: "form2" },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "label_essweb_ClaimType_form_noticeRequireLabel"
                                                          ),
                                                          required: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.before_is_required_acknowledgement,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.before_is_required_acknowledgement =
                                                              $$v
                                                          },
                                                          expression:
                                                            "before_is_required_acknowledgement",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "inputTextFiledMultiLang",
                                                        {
                                                          attrs: {
                                                            bindData:
                                                              _vm.before_acknowledge,
                                                            maxlength: "100",
                                                            label: _vm.$t(
                                                              "label_essweb_ClaimType_form_acknowledgeLabel"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              valueArr
                                                            ) {
                                                              _vm.before_acknowledge =
                                                                valueArr
                                                            },
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { staticClass: "mrc-grey" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "white",
                                      attrs: { elevation: 0 },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "transparent pa-8" },
                                        [
                                          _c(
                                            "v-container",
                                            {
                                              staticClass:
                                                "mrc-grey rounded-lg",
                                              attrs: { fluid: "" },
                                            },
                                            _vm._l(
                                              _vm.afterNoticeList,
                                              function (item, index) {
                                                return _c(
                                                  "v-sheet",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "rounded-lg pa-0 drag mt-2 mb-2",
                                                  },
                                                  [
                                                    _c("v-hover", {
                                                      attrs: {
                                                        "open-delay": "100",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var hover =
                                                                ref.hover
                                                              return [
                                                                _c(
                                                                  "v-card",
                                                                  {
                                                                    staticClass:
                                                                      "pa-2 d-flex rounded-lg align-center",
                                                                    attrs: {
                                                                      elevation:
                                                                        hover
                                                                          ? 4
                                                                          : 2,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "grey",
                                                                          iconClass:
                                                                            "dragvertical",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "36px",
                                                                          },
                                                                        attrs: {
                                                                          size: "36",
                                                                          fill: "black",
                                                                          iconClass:
                                                                            "arrow01",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-body-2",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                item[
                                                                                  "claim_type_notice_point_" +
                                                                                    item.number
                                                                                ]
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-spacer"
                                                                    ),
                                                                    hover
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.toEditNotice(
                                                                                    item,
                                                                                    "after"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "edit"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    hover
                                                                      ? _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onDeleteNotice(
                                                                                    item.number,
                                                                                    "after"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "material-icons-round",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "delete"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "v-form",
                                            { ref: "form3" },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "label_essweb_ClaimType_form_noticeRequireLabel"
                                                          ),
                                                          required: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.after_is_required_acknowledgement,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.after_is_required_acknowledgement =
                                                              $$v
                                                          },
                                                          expression:
                                                            "after_is_required_acknowledgement",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        xs: "12",
                                                        sm: "12",
                                                        md: "12",
                                                        lg: "12",
                                                        cols: "12",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "inputTextFiledMultiLang",
                                                        {
                                                          attrs: {
                                                            bindData:
                                                              _vm.after_acknowledge,
                                                            rules:
                                                              _vm.$GetRules(
                                                                [
                                                                  "_Require_Rules",
                                                                ],
                                                                [null]
                                                              ),
                                                            label: _vm.$t(
                                                              "label_essweb_ClaimType_form_acknowledgeLabel"
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              valueArr
                                                            ) {
                                                              _vm.after_acknowledge =
                                                                valueArr
                                                            },
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-5",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.claimTypeItemHeaders,
                          items: _vm.claimTypeItems,
                          border: "",
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_item_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toDeleteClaimItem(item.uuid)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("delete")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "my-2 text-capitalize",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.curSelectClaimItem =
                                              _vm.claimTypeItems
                                            _vm.newClaimItemDialog = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimType_form_dialog_addClaimItemBtnLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              style: {
                marginLeft: _vm.curStep == 4 ? "208px" : "0px",
                width: _vm.curStep == 4 ? "calc(100% - 208px)" : "100%",
              },
              attrs: {
                newBtn:
                  _vm.stepper.length == _vm.curStep && _vm.curStep != 0
                    ? true
                    : false,
                step: _vm.stepper.length == _vm.curStep ? false : true,
                onLoading: _vm.isLoading,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newClaimTransactionType", {
              attrs: {
                show: _vm.newTransactionTypeDialog,
                PropertyData: _vm.curPropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.newTransactionTypeDialog = false
                  _vm.curPropertyData = null
                },
                onNew: _vm.onNewTransactionType,
              },
            }),
            _c("newApprovalFlow", {
              attrs: {
                show: _vm.newApprovalFlowDialog,
                PropertyData: _vm.curFlowPropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.newApprovalFlowDialog = false
                  _vm.curflowPropertyData = null
                },
                onNew: _vm.onNewApprovalFlow,
              },
            }),
            _c("newNotice", {
              attrs: {
                show: _vm.showNewNotice,
                PropertyData: _vm.NoticePropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showNewNotice = false
                  _vm.NoticePropertyData = null
                },
                onNew: _vm.onNewNotice,
              },
            }),
            _c("newClaimItem", {
              attrs: {
                show: _vm.newClaimItemDialog,
                PorpertyData: _vm.curSelectClaimItem,
              },
              on: {
                close: function ($event) {
                  _vm.newClaimItemDialog = false
                },
                onSave: _vm.onEditClaimItem,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }